/**
 * Created by TzuHsing on 2020-10-13
 */
import React from 'react'
import { Modal, message, Table, Button } from 'antd'
import Popconfirm from '../../../components/Popconfirm/Popconfirm2'
import AddPackage from './AddPackage'
import NewPackageModal from './newPackageModal'
import { DISABLE, ENABLE } from '../constants'
import { changeToDecimal } from '../../../util'
import PackageDetail from './PackageDetail'
import { deleteEditPackage } from '../../../api/package'
import moment from 'moment'

export default class extends React.Component {
  state = {
    isLoading: false,
    typingPackageName: '',
    typingPackagePrice: '',
    typingPackageTime: '',
    purchaseStartTime: '00:00:00', // 新增限时开始时间
    purchaseEndTime: '00:00:00', // 新增限时结束时间
    purchaseWeekday: ['1', '1', '1', '1', '1', '1', '1'], // 新增选择日期
    isPurchaseLimitEnabled: false,
    allPackage: [],
    isShowPackageDetail: false,
    record: {},

    visible: false,
    packageId: '',
  }

  componentDidMount() {
    this.updatePackage()
  }

  updatePackage = async () => {
    this.setState({ isLoading: true }, async () => {
      await this.props.fetchAllPackage()
      this.setState({ isLoading: false })
    })
  }

  resetState() {
    this.setState({
      typingPackageName: '',
      typingPackagePrice: '',
      typingPackageTime: '',
      isLoading: false,
    })
  }

  handleCreatePackage = async () => {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        const {
          typingPackageName,
          typingPackagePrice,
          typingPackageTime,
          isBindAfterAdd,
          purchaseStartTime,
          purchaseEndTime,
          purchaseWeekday,
          isPurchaseLimitEnabled,
        } = this.state
        const isPromiseChange =
          /^\d+(\.\d{1,2})?$/.test(typingPackagePrice) &&
          /^\d+(\.\d{1,2})?$/.test(typingPackageTime)
        if (
          typingPackageName &&
          typingPackagePrice !== undefined &&
          !!typingPackageTime !== undefined &&
          isPromiseChange
        ) {
          const club = sessionStorage.getItem('club_id')
          let data = {
            club_id: +club,
            name: typingPackageName,
            amount: +typingPackagePrice * 100,
            duration: +typingPackageTime * 60,
            isPurchaseLimitEnabled: isPurchaseLimitEnabled ? 1 : 0,
          }
          if (isPurchaseLimitEnabled) {
            data = {
              ...data,
              purchaseStartTime,
              purchaseEndTime,
              purchaseWeekday: parseInt(purchaseWeekday.reverse().join(''), 2),
            }
          }
          this.props.fetchAddPackage(data, async (isSuccess, res) => {
            if (isSuccess) {
              if (isBindAfterAdd) {
                this.props.fetchBindPackage(
                  {
                    prepaid_ids: [res.data[0].id + ''],
                    table_ids: [this.props.record.table_id],
                    is_enabled: ENABLE,
                  },
                  async () => {
                    await this.updatePackage()
                    this.resetState()
                  }
                )
              } else {
                await this.updatePackage()
                this.resetState()
              }
            } else {
              this.setState({ isLoading: false }, () =>
                message.error(res ? res.detail : '服务暂不可用')
              )
            }
          })
        } else {
          this.setState({ isLoading: false }, () => message.error('请输入完整'))
        }
      }
    )
  }

  setTypingInfo = (typingAttr, value) => {
    this.setState(() => ({ [typingAttr]: value }))
  }

  setTypingSwitch = (typingAttr, value) => {
    this.setState((preState) => ({ [typingAttr]: !preState[typingAttr] }))
  }

  handleShowDetail(record) {
    this.props.setEditRecord(record)
    this.setState({
      record: record,
      isShowPackageDetail: true,
    })
  }

  handleDetailDisplay = () => {
    this.setState(
      {
        detailId: 0,
        isShowPackageDetail: false,
      },
      this.updatePackage
    )
  }

  handleDelete(id) {
    this.setState(
      {
        isLoading: true,
      },
      () => {
        // this.props.fetchEditPackage(
        //   {
        //     id,
        //     is_enabled: DISABLE,
        //   },
        //   (isSuccess) => {
        //     if (isSuccess) {
        //       this.updatePackage()
        //     } else {
        //       this.setState({ isLoading: false })
        //     }
        //   }
        // )
        deleteEditPackage([
          {
            prepaid: {
              id: id,
              isEnabled: 0,
            },
          },
        ])
          .then((res) => {
            if (res.status != 1) {
              message.error(res.detail)
              this.setState({ isLoading: false })
              return
            }
            message.success('删除成功')
          })
          .then(() => {
            this.updatePackage()
          })
      }
    )
  }

  // 关闭新建套餐模态窗
  handleCancel = () => {
    this.setState({
      visible: false,
      packageId: '',
    })
  }

  // 打开套餐详情
  showPackageDetail = (packageId) => {
    this.setState(
      {
        packageId: packageId,
      },
      () => {
        this.setState({
          visible: true,
        })
      }
    )
  }

  render() {
    const { isShowPackageManager, allPackage } = this.props
    const { isLoading, isShowPackageDetail } = this.state
    const column = [
      {
        title: 'id',
        dataIndex: 'id',
        key: 'id',
        defaultSortOrder: 'descend',
        sorter: (a, b) => (+a.id > +b.id ? 1 : -1),
      },
      {
        title: '套餐名',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: '价格(元)',
        dataIndex: 'amount',
        key: 'amount',
        render: (text, record) => <span>{record.amount / 100}</span>,
      },
      {
        title: '时长(分钟)',
        dataIndex: 'duration',
        key: 'duration',
        render: (text, record) => (
          <span>{+changeToDecimal(+record.duration / 60)}</span>
        ),
      },
      {
        title: '限时购买使用',
        dataIndex: 'purchaseWeekday',
        key: 'purchaseWeekday',
        render: (text, record) => {
          const showText = this.props.timeLimitText(record)
          return <span>{showText}</span>
        },
      },
      {
        title: '操作',
        key: 'action',
        render: (text, record) => (
          <div>
            <Button
              type="primary"
              style={{ marginRight: '20px' }}
              onClick={() => this.showPackageDetail(record.id)}
            >
              详情
            </Button>

            <Button
              type="primary"
              style={{ marginRight: '20px' }}
              onClick={() => this.handleShowDetail(record)}
            >
              球台使用情况
            </Button>

            <Popconfirm
              title="您确定要删除吗?"
              onConfirm={() => this.handleDelete(record.id)}
              okText="确认"
              cancelText="取消"
            >
              <Button type="primary" danger>
                删除
              </Button>
            </Popconfirm>
          </div>
        ),
      },
    ]
    return (
      <div>
        <Modal
          title="套餐管理"
          visible={isShowPackageManager}
          onOk={this.props.handleOk}
          className={'packageManager'}
          onCancel={this.props.handleCancel}
          width="80vw"
        >
          {/* <AddPackage
            {...this.state}
            setTypingInfo={(typingAttr, value) =>
              this.setTypingInfo(typingAttr, value)
            }
            setTypingSwitch={(typingAttr, value) =>
              this.setTypingSwitch(typingAttr, value)
            }
            handleCreatePackage={() => this.handleCreatePackage()}
            hideSwitch
          /> */}
          <div>
            <Button
              type="primary"
              onClick={() => {
                this.setState({
                  visible: true,
                })
              }}
            >
              新建套餐
            </Button>
          </div>
          <div className="handleList-box">
            <div className="enablePackage">
              <h3 style={{ marginTop: '0.5em' }}>全部套餐</h3>
              <Table
                rowKey="id"
                bordered
                columns={column}
                loading={isLoading}
                dataSource={allPackage}
                pagination={{ pageSize: 10 }}
              />
            </div>
          </div>
          {isShowPackageDetail && (
            <PackageDetail
              {...this.state}
              {...this.props}
              onOk={() => this.handleDetailDisplay()}
              onCancel={() => this.handleDetailDisplay()}
            />
          )}
        </Modal>

        {this.state.visible && (
          <NewPackageModal
            id={this.state.packageId}
            visible={this.state.visible}
            handleCancelPackage={this.handleCancel}
            updatePackageView={this.props.fetchAllPackage}
            isNotTable={true}
          ></NewPackageModal>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubTable/component/packageManager.js